import React from 'react'
import { Helmet } from 'react-helmet'

import { EuiSpacer, EuiTitle } from '@elastic/eui'

import { ICampaignBuilderWorkflowStep } from 'features/builders/createCampaign/creativeBuilder/CreativeBuilderWorkflowManager'

import DisplayAdUploader from '../DisplayAdUploader'

const UploadStep = ({ onBack }: ICampaignBuilderWorkflowStep) => {
  const goToStart = () => {
    onBack?.()
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Upload Display Ad</title>
      </Helmet>
      <EuiTitle size='s'>
        <h3>Upload Your Ad</h3>
      </EuiTitle>
      <EuiSpacer size='m' />
      <DisplayAdUploader onBackClick={goToStart} />
    </React.Fragment>
  )
}

export default UploadStep
